<script>
import { mapGetters, mapActions } from 'vuex';
import EstagioColumn from './EstagioColumn.vue';

export default {
  name: 'KanbanBoard',
  components: { EstagioColumn },
  computed: {
    // Usa conversasFiltradas pra refletir busca/UF/status/etiqueta do header.
    ...mapGetters('atendimento', ['estagios', 'conversas', 'conversasFiltradas']),
    estagiosOrdenados() {
      // Estágios finalizados (tipo='finalizado': Mobilizado, Encerrado, etc.)
      // saem do kanban — pipeline ativo é só pra conversas em movimento.
      // Conversas finalizadas continuam acessíveis via DB / relatórios.
      return [...this.estagios]
        .filter((e) => e.tipo !== 'finalizado')
        .sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
    },
  },
  methods: {
    ...mapActions('atendimento', ['selecionarConversa', 'moverConversa']),
    conversasDoEstagio(estagioId) {
      return this.conversasFiltradas
        .filter((c) => {
          if (c.estagio_id !== estagioId) return false;
          // Defesa em profundidade — mesmo se um card ficou com referência
          // a estágio finalizado, não aparece no board.
          if (c.estagio && c.estagio.tipo === 'finalizado') return false;
          return true;
        })
        .sort((a, b) => {
          const ta = new Date(a.ultima_mensagem_em || a.updated_at || 0).getTime();
          const tb = new Date(b.ultima_mensagem_em || b.updated_at || 0).getTime();
          return tb - ta;
        });
    },
    onCardClick(conversa) {
      this.selecionarConversa(conversa.id);
    },
    async onDrop({ conversaId, estagioId }) {
      const atual = this.conversas.find((c) => c.id === conversaId);
      if (!atual || atual.estagio_id === estagioId) return;
      try {
        await this.moverConversa({ conversaId, estagioId });
      } catch (error) {
        console.error('[atendimento] mover conversa falhou:', error);
      }
    },
  },
};
</script>

<template>
  <div class="kanban-wrapper">
    <div v-if="!estagios.length" class="text-muted text-center py-5">
      <i class="ri-error-warning-line" style="font-size: 2rem;"></i>
      <div class="mt-2">Nenhum estágio configurado.</div>
      <small>Verifique se o autoseed do backend rodou (4 estágios padrão devem ter sido criados).</small>
    </div>
    <div v-else class="kanban-board">
      <EstagioColumn
        v-for="estagio in estagiosOrdenados"
        :key="estagio.id"
        :estagio="estagio"
        :conversas="conversasDoEstagio(estagio.id)"
        @card-click="onCardClick"
        @drop="onDrop"
      />
    </div>
  </div>
</template>

<style scoped>
.kanban-wrapper {
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 0.75rem;
  background: var(--vz-body-bg);
  border: 1px solid var(--vz-border-color);
  border-radius: 0.5rem;
}
.kanban-board {
  display: flex;
  align-items: stretch;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

:global([data-bs-theme="dark"]) .kanban-wrapper {
  background: var(--vz-body-bg);
  border-color: var(--vz-border-color);
}
</style>
